import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["checked"]
const _hoisted_2 = ["data-cy"]

import VRuntimeTemplate from "vue3-runtime-template";
import Multiselect from "@vueform/multiselect";
import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'customMultiSelectSearch',
  props: {
  options: { type: Array, required: true },
  trackBy: { type: String, required: true },
  label: { type: String, required: false, default: "" },
  placeholder: { type: String, required: false, default: "" },
  modelValue: { type: Array, required: true },
  showCheckBox: { type: Boolean, required: false, default: false },
  validation: { type: Object, default: () => ({}) },
  dataCyId: { type: String, default: "" },
},
  emits: [
  "update:modelValue",
  "close:modal",
  "update:select",
  "change:modal",
],
  setup(__props, { emit }) {

const props = __props;




const updateMultiSelect = ref(props.modelValue);

watch(
  [() => updateMultiSelect.value],
  () => {
    emit("update:modelValue", updateMultiSelect.value);
  },
  { immediate: true },
);

const isSelected = (option) => {
  const isSelect = updateMultiSelect.value.find(
    (x) => x[props.trackBy] === option[props.trackBy],
  );

  return isSelect !== undefined;
};

let data = ref({
  mode: "tags",
  value: updateMultiSelect.value,
  placeholder: props.placeholder,
  closeOnSelect: false,
  searchable: true,
  trackBy: props.trackBy,
  label: props.label,
  hideSelected: false,
  object: true,
  options: props.options,
  valueProp: props.trackBy,
});

const onSelect = (option) => {
  option.selected = !option.selected;
  const foundIndex = updateMultiSelect.value.findIndex(
    (x) => x[props.trackBy] == option[props.trackBy],
  );
  updateMultiSelect.value[foundIndex] = option;
};

const onChange = () => {
  emit("change:modal", updateMultiSelect);
};

const onClose = () => emit("close:modal", updateMultiSelect);

watch(
  [() => props.options],
  () => {
    data.value = {
      ...data.value,
      options: props.options,
    };
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Multiselect), _mergeProps(_unref(data), {
      modelValue: updateMultiSelect.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((updateMultiSelect).value = $event)),
      class: ['custom-multiselect', props.validation.$error ? 'invalid' : ''],
      "data-cy": "custom-multiselect",
      onSelect: onSelect,
      onDeselect: onSelect,
      onClear: _ctx.onClear,
      onClose: onClose,
      onChange: onChange
    }), {
      option: _withCtx(({ option }) => [
        (__props.showCheckBox)
          ? (_openBlock(), _createElementBlock("input", {
              key: 0,
              type: "checkbox",
              checked: isSelected(option)
            }, null, 8, _hoisted_1))
          : _createCommentVNode("", true),
        _createElementVNode("label", {
          "data-cy": `${__props.dataCyId}-${_unref(data).label}`
        }, _toDisplayString(option[_unref(data).label]), 9, _hoisted_2)
      ]),
      _: 1
    }, 16, ["modelValue", "class", "onClear"]),
    _createVNode(_component_b_form_invalid_feedback, {
      class: _normalizeClass({ 'is-invalid': __props.validation.$error })
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(VRuntimeTemplate), {
          template: __props.validation?.$errors?.[0]?.$message
        }, null, 8, ["template"])
      ]),
      _: 1
    }, 8, ["class"])
  ], 64))
}
}

})